/**
 * Utilitário para abrir o Painel de Detalhes em nova janela separada (pop-up)
 * 
 * @param {Object} options - Opções para abertura da janela
 * @param {number} options.width - Largura da janela (padrão: 1400)
 * @param {number} options.height - Altura da janela (padrão: 900)
 * @param {boolean} options.scrollbars - Mostrar scrollbars (padrão: true)
 * @param {boolean} options.resizable - Permitir redimensionar (padrão: true)
 * @param {boolean} options.fullscreen - Tentar abrir em fullscreen automaticamente (padrão: false)
 * @param {string} options.testeId - Identificador de uma pré-visualização local e isolada
 * @returns {Window|null} - Referência da janela aberta ou null se falhar
 */
export function abrirPainelDetalhes(options = {}) {
  const {
    width = 1400,
    height = 900,
    scrollbars = true,
    fullscreen = false,
    testeId = null
  } = options;

  // Construir URL baseada na localização atual
  const baseUrl = window.location.origin;
  const pathname = '/painelatendimento/detalhes';
  const url = `${baseUrl}${pathname}${testeId ? `?teste=${encodeURIComponent(testeId)}` : ''}`;

  // Nome único da janela para evitar múltiplas instâncias
  const windowName = 'painelDetalhes';

  // Configurar features da janela pop-up
  const features = [
    `width=${width}`,
    `height=${height}`,
    scrollbars ? 'scrollbars=yes' : 'scrollbars=no',
    'resizable=yes', // Sempre redimensionável
    'movable=yes',   // Garantir que seja movível (Chrome/Edge)
    'toolbar=no',
    'menubar=no',
    'location=no',
    'directories=no',
    'status=no',
    'dependent=yes'
  ].join(',');

  try {
    // Tentar abrir/focar janela existente primeiro
    let novaJanela = window.open('', windowName);
    
    // Se a janela não existe ou foi fechada, abrir nova
    if (!novaJanela || novaJanela.closed) {
      novaJanela = window.open(url, windowName, features);
    } else {
      // Se a janela já existe, apenas focar nela e recarregar
      novaJanela.focus();
      novaJanela.location.href = url;
    }
    
    if (!novaJanela || novaJanela.closed) {
      alert('Não foi possível abrir o Painel de Detalhes. Verifique se o popup está bloqueado.');
      return null;
    }

    // Aguardar a janela carregar
    if (novaJanela.addEventListener) {
      novaJanela.addEventListener('load', () => {
        novaJanela.focus();

        // Se fullscreen, tentar entrar em fullscreen
        if (fullscreen) {
          setTimeout(() => {
            if (novaJanela.document && novaJanela.document.documentElement && novaJanela.document.documentElement.requestFullscreen) {
              novaJanela.document.documentElement.requestFullscreen().catch(err => {
                console.log('Não foi possível entrar em fullscreen automaticamente:', err);
              });
            }
          }, 500);
        }
      });
    }

    // Focar imediatamente
    novaJanela.focus();
    
    return novaJanela;
  } catch (error) {
    console.error('Erro ao abrir Painel de Detalhes:', error);
    alert('Erro ao abrir o Painel de Detalhes: ' + error.message);
    return null;
  }
}

/**
 * Função de conveniência simples
 */
export const abrirDetalhes = () => abrirPainelDetalhes();
